import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from "@src/service";
import { IGetNtripRequest, IGetNtripResponse, ISendCommandRequest, ITakeOffRequest, IUpdateNtripRequest } from './types';

export const droneFeatureApi = createApi({
  baseQuery: axiosBaseQuery(),
  reducerPath: 'droneFeatureApi',
  tagTypes: ['Orders', 'OrderDetails', 'Drone'],
  endpoints: (builder) => ({

    takeOff: builder.mutation<void, ITakeOffRequest>({
      invalidatesTags: ['Orders', 'OrderDetails'],
      query: ({droneId, altitude, unitSystem}) => ({
        url: `/api/v2/orders/direct-command/${droneId}/TAKE_OFF/${altitude}`,
        method: 'POST',
        data: { unitSystem }
      })
    }),

    sendCommand: builder.mutation<void, ISendCommandRequest>({
      query: ({ droneId, command }) => ({
        url: `/api/v2/orders/direct-command/${droneId}/${command}`,
        method: 'POST',
      })
    }),

    updateNtrip: builder.mutation<void, IUpdateNtripRequest>({
      invalidatesTags: ['Drone'],
      query: ({ droneId, ...data }) => ({
        url: `/api/v1/drone/${droneId}/ntrip`,
        method: 'PUT',
        data,
      })
    }),
    getNtrip: builder.query<IGetNtripResponse, IGetNtripRequest>({
      query: ({ droneId }) => ({
        url: `/api/v1/drone/${droneId}/ntrip`,
        method: 'GET',
      }),
      providesTags: ['Drone'],
    }),
  })
});

export const { 
  useSendCommandMutation,
  useTakeOffMutation,
  useUpdateNtripMutation,
  useGetNtripQuery,
} = droneFeatureApi;